<app-commitment-sidebar-title
  [showBackButton]="true"
  [title]="model().id ? 'Edit Prime Contract' : 'Add Prime Contract'"
  (goBack)="goBack()"
>
</app-commitment-sidebar-title>

<ng-scrollbar #scrollbar class="std-scrollbar flex-1" [appearance]="'compact'" orientation="vertical">
  <div class="flex mb-2.5 flex-col flex-1">
    <form class="h-full" #COMarkups="ngForm" role="form">
      @for (group of model().markupGroups; track groupIndex; let groupIndex = $index; let isLast = $last) {
        <app-commitment-entry-text
          [disableRemoveEntry]="groupIndex < model().markupGroups.length - 1"
          (removeClicked)="removeGroup(groupIndex)"
          [index]="groupIndex"
          [showRemoveIcon]="true"
          text="Change Order Markup Group"
        ></app-commitment-entry-text>

        <div [class.mb-4]="isLast" class="mx-7">
          <app-dropdown
            [required]="true"
            [ngModel]="group.selectedOptionId"
            (ngModelChange)="selectMarkupCombination($event, group, groupIndex)"
            placeholder="Select Markup Base"
            label="Select Markup Base"
            [name]="'markup_base_group_' + groupIndex"
            class="w-full"
            [options]="markupBaseOptions()[groupIndex]"
            optionValue="id"
            optionLabel="label"
            [disabledOptionIds]="disabledMarkupBaseOptionIds()"
          >
          </app-dropdown>
          @for (markup of group.markups; track markupIndex; let markupIndex = $index) {
            <div class="flex items-center gap-2">
              <app-dropdown
                [required]="true"
                [optionLabel]="null"
                [optionValue]="'description_id'"
                [ngModel]="markup.sov_id"
                (ngModelChange)="updateMarkupSovId(groupIndex, markupIndex, $event)"
                [placeholder]="'Schedule Of Value ' + (markupIndex + 1)"
                [label]="'Schedule Of Value ' + (markupIndex + 1)"
                [name]="'schedule_of_value_' + groupIndex + '_' + markupIndex"
                class="w-full"
                [options]="allScheduleOfValues()"
                [disabledOptionIds]="disabledSOVIds()"
              >
                <ng-template #selectedContent #optionContent let-option>
                  <div class="capitalize text-navy-900 text-medium">{{ option.name }}</div>
                </ng-template>
              </app-dropdown>

              <app-floating-input
                [required]="true"
                class="w-full max-w-32 overflow-hidden"
                [(ngModel)]="markup.rate"
                [min]="0"
                [max]="100"
                [name]="'rate_' + groupIndex + '_' + markupIndex"
                label="Rate %"
                placeholder="Rate %"
                type="number"
              ></app-floating-input>

              <app-add-remove-buttons
                class="mt-3.5"
                (removeItem)="removeItem(groupIndex, markupIndex)"
                (addItem)="addItem(groupIndex, markupIndex)"
              >
              </app-add-remove-buttons>
            </div>
          }
        </div>
      }
      <app-simple-button
        class="mx-7 my-2 flex"
        size="large"
        [wrapperClass]="{ 'w-full': true }"
        buttonStyle="color_secondary_border"
        (click)="addGroup()"
        >Add Markup Group
      </app-simple-button>
    </form>
  </div>
</ng-scrollbar>
<div class="flex my-6 mx-7 justify-end gap-4">
  <app-simple-button (click)="goToNextPage()">Next</app-simple-button>
</div>
